import { PolicyType as SdkPolicyType } from "@bitwarden/sdk-internal";

// Re-export the SdkPolicyType so we have a single source of truth
export { SdkPolicyType as PolicyType };
